module.exports = __webpack_public_path__ + "img/nurowski.976a3ed7.jpg";